<template>
    <v-app id="inspire">
        <v-container fill-height
                        fluid>
            <v-row align="center"
                    justify="center">
                <v-col cols="12"
                       sm="8"
                       md="4">

                    <v-alert type="info" v-if="login_info != ''">
                        <div v-html="login_info"></div>
                    </v-alert>

                    <v-alert type="error" v-if="err_message != ''">
                        {{ err_message }}
                    </v-alert>
                    
                    <v-form method="post" action="/Login/CheckLogin">

                        <input type="hidden" name="ReturnUrl" v-model="return_url">
                        <v-card class="elevation-12">
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title>{{ sys_nm }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <space>Ver - {{ app_version }}</space>
                            </v-toolbar>
                            <v-card-text>
                                <input type="hidden" name="mode" v-model="mode">
                                <v-text-field label="ログインID"
                                              name="logincode"
                                              prepend-icon="mdi-store">

                                </v-text-field>
                                <v-text-field label="パスワード"
                                              name="password"
                                              prepend-icon="mdi-lock"
                                              type="password">

                                </v-text-field>
                                <v-row dense>
                                    <v-col>
                                        <v-checkbox v-model="company_check"
                                                    :label="kaisya_nm + 'としてログイン'"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-on:click="setLocalStorage()"
                                       color="primary"
                                       type="submit">
                                    ログイン
                                </v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    export default {

        mounted: function () {
            this.$nextTick(function () {
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                this.onGetCodeCategory();
                this.onGetCodeCategory_Kaisya();    
                this.return_url = new URL(location.href).searchParams.get('ReturnUrl')

                fetch("./login_info.html").then((res) => {
                    res.text().then((html) => {
                        this.login_info = html;
                    });
                })
            });
            this.$vuetify.theme.themes.light.primary = this.sys_color;
            this.getLocalStorage();
        },
        watch: {
            company_check: function (newVal) {
                if (newVal == true) {
                    this.mode = '2';
                    return;
                } else {
                    this.mode = '1';
                }
            }
        },
        data: () => ({
            return_url: '',
            app_version: g_version,
            err_message: g_errmessage,
            login_info: '',
            company_check: false,
            mode: '1',
            sys_nm: '',
            kaisya_nm: '',
            searchCategory: {
                category_key: '',
                category_cd: '',
            },
            items: [],
            sys_color: g_sys_color,
           
        }),
        methods: {
            getLocalStorage: function () {
                if (localStorage.CompanyCheck == undefined) {
                    this.company_check = false;
                } else {
                    this.company_check = JSON.parse(localStorage.CompanyCheck);
                }
                console.log("getLocalStorage.company_check = " + this.company_check);
            },
            setLocalStorage: function () {
                localStorage.setItem('CompanyCheck', this.company_check);
                console.log("setLocalStorage.company_check = " + this.company_check);
            },
            async onGetCodeCategory() {
                try {
                    var params = new URLSearchParams();
                    this.searchCategory.category_key = "LOGIN_SYSTEM_NM";
                    this.searchCategory.category_cd = "";
                    this.items = [];
                    params.append('param', JSON.stringify(this.searchCategory));
                    let res = await this.axios_post('/CodeCategory/Get', params);
                    this.sys_nm = res.data.items[0].category_nm;
                } catch (err) {
                    console.log(err);
                }
            },
            async onGetCodeCategory_Kaisya() {
                try {
                    var params = new URLSearchParams();
                    this.searchCategory.category_key = "JIGYOGAISYA_NM";
                    this.searchCategory.category_cd = "";
                    this.items = [];
                    params.append('param', JSON.stringify(this.searchCategory));
                    let res = await this.axios_post('/CodeCategory/Get', params);
                    this.kaisya_nm = res.data.items[0].category_nm;
                } catch (err) {
                    console.log(err);
                }
            },
        }
    }
</script>
